import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Button = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 25">
    <path
      fill-rule="nonzero"
      d="m20 16.205 2.96 2.302c.477.37.66.98.463 1.553a1.376 1.376 0 0 1-1.318.941h-1.95a.394.394 0 0 0-.314.157l-1.338 1.783a1.383 1.383 0 0 1-1.495.505A1.385 1.385 0 0 1 16 22.231L15.707 19H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8.205ZM3 17c0 .551.449 1 1 1h11.616l-.218-2.404c-.051-.562.225-1.08.72-1.35a1.373 1.373 0 0 1 1.523.124L19 15.427V8c0-.551-.449-1-1-1H4c-.551 0-1 .449-1 1v9Zm19.105 3.001c.26 0 .35-.203.372-.266a.385.385 0 0 0-.13-.44l-2.397-1.862-.95-.74-1.974-1.534a.38.38 0 0 0-.43-.035.387.387 0 0 0-.202.382L16.62 18l.046.505.33 3.637a.383.383 0 0 0 .285.341c.063.02.273.058.422-.141l1.338-1.783c.261-.35.678-.558 1.115-.558h1.949ZM8 12h6v1H8v-1Z"
    />
  </SvgIcon>
);

export default Button;
